import { all } from "redux-saga/effects";

import { registerBookingTableSaga } from "./BookingTableStore/bookingTableSaga";
import { registerChargingDataSaga } from "./ChargingDataStore/chargingDataSaga";
import { registerChargingStationSaga } from "./ChargingStationStore/chargingStationSaga";
import { registerCustomerTableSaga } from "./CustomerTableStore/customerTableSaga";
import { registerHelpSupportSaga } from "./HelpSupportStore/helpSupportSaga";
import { registerPersonalDetailSaga } from "./CustomerDetailStore/customerDetailSaga";
import { registerStationdetailSaga } from "./StationDetailStore/stationDetailSaga";
import { registerNotificationSaga } from "./NotificationStore/notificationSaga";
import { registerCommonSagas } from "./common/commonSagas";
import { registerVendorSaga } from "./VendorStore/vendorSaga";
import { registerDashboardSaga } from "./DashboardStore/dashboardSaga";
import { registerManufacturertableSaga } from "./ManufacturerStore/ManufacturerSaga";
import { registerConnectorstableSaga } from "./ConnectorsTableStore/ConnectorsTableSaga";
import { registergetAmenitiestabletableSaga } from "./AmenitiesTableStore/AmenitiesTableSaga";
import { registerNetworktableSaga} from "./ChargingNetworkStore/NetworkTable.Saga"
import { registerAdmintableSaga } from "./AdminVendorStore/AdminTableSaga";
import { registerConfigtableSaga } from "./VendorConfigStore/ConfigTableSaga";
import { registerDetailstableSaga } from "./ManufacturViewDetailStore/DetailsTableSaga";
import { registerCoupanCitySaga } from "./CoupanCitylistStore/CoupanCitySaga";
import { registerChargingNetworkWiseSaga } from "./ChargingNetworkWiseStore/ChargingNetworkWiseSaga";
import { registerVendordetailSaga } from "./VendorDetailsStore/VendorDetailSaga";
import { registerGlobleConfigurationSaga } from "./Configuration/ConfigurationSaga";
import { registergetFaqSaga } from "./FaqTableStore/FaqSaga";
import { registergetLeadsSaga } from "./Leads/LeadsSaga";
import { VehcileDataSaga } from "./vehicles/VehicleSaga";
import { ConnectorDataSaga } from "./Connector/ConnectorSaga";
import { RequestDataSaga } from "./Request/RequestSaga";
import { NavigationDataSaga } from "./Navigation/NavigationSaga";
import { SearchHistoryDataSaga } from "./SearchHistory/SearchHistorySaga";
import { CheckIncustomerDataSaga } from "./CheckIn/CheckInCustomerSaga";
import { FeedbackDataSaga } from "./Feedback/FeedbackSaga";
import { addChargingStationSaga } from "./AddStationStore/addStationSaga";
import { TripDetailDataSaga } from "./TripDtailsStore/TripDetailSaga";


function* rootSaga() {
  yield all([
    registerChargingStationSaga(),
    registerChargingDataSaga(),
    registerBookingTableSaga(),
    registerCustomerTableSaga(),
    registerPersonalDetailSaga(),
    registerCommonSagas(),
    registerVendorSaga(),
    registerHelpSupportSaga(),
    registerStationdetailSaga(),
    registerNotificationSaga(),
    registerDashboardSaga(),
    registerManufacturertableSaga(),
    registerConnectorstableSaga(),
    registergetAmenitiestabletableSaga(),
    registerNetworktableSaga(),
    registerAdmintableSaga(),
    registerConfigtableSaga(),
    registerDetailstableSaga(),
    registerCoupanCitySaga(), 
    registerChargingNetworkWiseSaga(),
    registerVendordetailSaga(),
    registerGlobleConfigurationSaga(),
    registergetFaqSaga(),
    registergetLeadsSaga(),
    VehcileDataSaga(),
    ConnectorDataSaga(),
    RequestDataSaga(),
    NavigationDataSaga(),
    TripDetailDataSaga(),
    SearchHistoryDataSaga(),
    CheckIncustomerDataSaga(),
    FeedbackDataSaga(),
    addChargingStationSaga() 
  ]);
}

export default rootSaga;
